import { parseQueryString } from './url';
import { isWindowDefined } from './utils';

const initialQs = parseQueryString(isWindowDefined ? window.location.search : '');

export function featureEnabled(id: string) {
  return Object.keys(initialQs).includes(`features:${id}`);
}
